<!--Report Filters-->
<div class="filter-bar">
    <button mat-stroked-button color="primary" (click)="openFilterDialog()">
        Filter States and Level <vulcan-icon icon="funnel-simple"></vulcan-icon>
    </button>

    <button mat-stroked-button color="primary" (click)="openDateRangeDialog()">
        Set Date Range <vulcan-icon icon="calendar"></vulcan-icon>
    </button>

    <button mat-stroked-button matTooltip="Export" matTooltipPosition="above" matTooltipShowDelay="250" [matMenuTriggerFor]="menu">
        <vulcan-icon icon="export"></vulcan-icon>
    </button>
</div>
<mat-menu #menu="matMenu" overlapTrigger>
    <button (click)="exportTable()" mat-menu-item>Export Table As CSV</button>
</mat-menu>

<div class="filters extra-row details">
    <p><b>Aggregation Level:</b> {{ level() | aggregationLevel }}</p>
    <p><b>Start:</b> {{ dateRangeForm.value.start | date }}</p>
    <p><b>End:</b> {{ dateRangeForm.value.end | date }}</p>
</div>

@if (level().toString() === 'state') {
<div class="filters extra-row state-chip-list">
    <span>States:</span>
    <eaglei-filter-chip-list (change)="updateSelectedStates($event)" [states]="selectedStates()"></eaglei-filter-chip-list>
</div>
}

<div class="features">
    <mat-card class="chart">
        <mat-card-header> {{ chartHeader() }} </mat-card-header>
        <mat-card-content>
            @if (showChart()) {
            <eaglei-nom-chart
                [aggregationLevel]="level()"
                [startDate]="startAsMoment()"
                [endDate]="endAsMoment()"
                [states]="selectedState()"
                [normalOutageLevel]="selectedNormalOutage()"></eaglei-nom-chart>
            }
            <div [ngClass]="{invisible: !selectedState()?.length}"></div>
        </mat-card-content>

        @if (!showChart()) {
        <div class="auto-mask hide-mask">
            <span class="mask-message">
                <span>{{ chartMask() }}</span>
            </span>
        </div>
        }
    </mat-card>

    <mat-card class="map">
        <mat-card-content>
            @if (showMap()) {
            <eaglei-leaflet-map [mapOptions]="mapOptions"></eaglei-leaflet-map>
            <div class="legend">
                @if (selectedStates().length > 1) {
                <mat-hint>Range: </mat-hint>
                }
                <mat-checkbox color="primary" [(ngModel)]="showCountAboveNormal" (change)="toggleData($event)">
                    Show Count Above Normal
                </mat-checkbox>
            </div>
            @if (selectedStates().length > 1) {
            <div class="range">
                <span class="scale-header">{{ scaleHeader() }}</span>
                <div class="scale">
                    @for (color of colorScale(); track $index) {
                    <div class="color" [ngStyle]="{backgroundColor: color}">
                        <span>{{ colorRange(color) }}</span>
                    </div>
                    }
                </div>
            </div>
            }
            <!--  -->
            }
        </mat-card-content>

        @if (!showMap()) {
        <div class="auto-mask hide-mask">
            <span class="mask-message">
                <span>The map can not display utility aggregation levels</span>
            </span>
        </div>
        }
    </mat-card>
</div>

<div class="table-section">
    <mat-card>
        <mat-card-content>
            <div class="table-container">
                <table mat-table #tableSort="matSort" [dataSource]="dataSource" matSort [matSortDisableClear]="true" matSortDirection="asc">
                    <tr mat-header-row *matHeaderRowDef="columns()"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: columns()"
                        (click)="setSelectedStateForChart(row)"
                        class="clickable hoverable"></tr>

                    <ng-container *matNoDataRow>
                        <td>No results match your filters</td>
                    </ng-container>

                    <ng-container matColumnDef="stateName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="stateName" [sort]="tableSort"></eaglei-table-sort-header>State Name
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.stateName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="countyName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="countyName" [sort]="tableSort"></eaglei-table-sort-header>County Name
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.countyName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="utilityName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="utilityName" [sort]="tableSort"></eaglei-table-sort-header>Utility Name
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.utilityName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="subUtilityName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="subUtilityName" [sort]="tableSort"></eaglei-table-sort-header>Sub utility
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.subUtilityName || 'Not Available' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lastCalculationDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="lastCalculationDate" [sort]="tableSort"></eaglei-table-sort-header>Last
                            Calculated
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.lastCalculationDate | date }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="normalValue">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="normalValue" [sort]="tableSort"></eaglei-table-sort-header>Normal Value
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.normalValue | number }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="countAboveNormal">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="countAboveNormal" [sort]="tableSort"></eaglei-table-sort-header>Count
                            Above Normal
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.countAboveNormal }}
                        </td>
                    </ng-container>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons> </mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
